var render = function render(){var _vm=this,_c=_vm._self._c;return (
        _vm.hasStrategy &&
        (_vm.isAdmin ||
            _vm.isLocalAdministrator ||
            _vm.isGod ||
            (_vm.isUser && _vm.strategyViewer))
    )?_c('HeaderDropdown',[_c('template',{slot:"header"},[_c('span',{staticClass:"active"},[_vm._v("Strategy")])]),_c('template',{slot:"dropdown"},[_c('b-dropdown-item',{attrs:{"to":"/v2/strategy/onepage"}},[_c('span',[_vm._v("OnePage")])])],1)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }